import styled from 'styled-components';

interface WrapperProps {
  width: string;
  height: string;
  transitionSpeed: number;
  initTransitionStyles?: string;
  hoverTransitionStyles?: string;
  classNameOverride?: string;
}

export const ElementHoverWrapper = styled.div<WrapperProps>`
  position: relative;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  > *:last-child {
    opacity: 0;
    z-index: 1;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transition: ${({ transitionSpeed }) => transitionSpeed}s;
    ${({ initTransitionStyles }) => initTransitionStyles}
  }
  &:hover,
  &:focus,
  &:focus-within {
    > *:last-child {
      opacity: 1;
      ${({ hoverTransitionStyles }) => hoverTransitionStyles}
    }
  }
`;

export const ClassNameHoverWrapper = styled.div<WrapperProps>`
  position: relative;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  &:not(:hover, :focus, :active, :focus-within) {
    .hover-content {
      visibility: hidden;
    }
    .hover-content,
    .hover-toggle-data {
      opacity: 0;
      z-index: 0;
      transition: ${({ transitionSpeed }) => transitionSpeed}s;
      ${({ initTransitionStyles }) => initTransitionStyles}
    }
  }
  &:hover,
  &:active,
  &:focus,
  &:focus-within {
    .hover-content,
    .hover-toggle-data {
      visibility: visible;
      z-index: 1;
      opacity: 1;
      transition: ${({ transitionSpeed }) => transitionSpeed}s;
      ${({ hoverTransitionStyles }) => hoverTransitionStyles}
    }
    .hide-hover-content {
      visibility: hidden;
    }
  }
`;
